<template class="as-page-header">
  <div class="as-page-header__heading">
    <button type="button" class="btn btn-icon" click.delegate="back()" if.bind="backVisible">
      <i class="fas fa-chevron-left"></i>
    </button>
    <h4 class="d-none d-sm-block" if.bind="heading" innerhtml="${heading | sanitizeHTML}"></h4>
    <h4 class="d-block d-sm-none" if.bind="heading && displayHeadingOnMobile" innerhtml="${heading | sanitizeHTML}"></h4>
  </div>
  <div class="as-page-header__aside">
    <slot name="aside"></slot>
  </div>
</template>
